function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 747;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/platform/instantiation/common
// module id = 747
// module chunks = 0